import React ,{useEffect} from 'react';
import './App.css';
import Header from './Header';
import Home from './Home';
import {BrowserRouter as Router, Switch,Route} from "react-router-dom";
import Checkout from './Checkout';
import Login from './Login';
import { useStateValue } from './StateProvider';
import { auth } from './firebase';
import Payment from './Payment';
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import Orders from './Orders';

const promise = loadStripe("pk_test_51HjibfB4IeBkqqmNvc0iLqEkzblmMGM0k0zI7TixL3tm5o20wL7AxYW3pgY6AbHmfzYNYAAgcA6UUZSXwh8KBAJM00Y4bQrTjN");




function App() {
  const [{},dispatch] =useStateValue();
  useEffect(()=> {
    /// it will only run when app componet loads ..
     auth.onAuthStateChanged(authUser => {
       console.log("THE USER IS >>> " ,authUser);
       if(authUser){
         // the just logged in/ the user was logged in 
        dispatch( {
            type : "SET_USER",
            user:authUser
        })
        }else {
         //user just logout
        dispatch({
          type:"SET_USER",
          user:null
        })
        }
     })
  },[])

  return (
    <Router>
    <div className="app">
    
      <Switch>
      <Route path="/orders">
          <Header/>
          <Orders />
        </Route>
        <Route path="/login">
          <Login />
        </Route>
        
        <Route path='/checkout'>
           <Header/>
           <Checkout />
        </Route>
        
        <Route path='/payment'>
           <Header/>
           <Elements stripe={promise}>
           <Payment />
           </Elements>
           
        </Route>

        <Route path="/">
        <Header/>
        <Home />
       </Route>

      </Switch>
      
     
    </div>
    </Router>
  );
}

export default App;
